import React, { FC } from 'react'
import styles from 'styles/components/calendar.module.scss'
import addDays from 'date-fns/addDays'
import { useDispatch, useSelector } from 'react-redux'
import { State } from 'index'
import { handleCurrentDate } from 'reducks/calendar/operations'
import { getCurrentDate } from 'reducks/calendar/selectors'

type Props = {
  label: string
  type: 'prev' | 'next'
}

const DailyArrowButton: FC<Props> = React.memo((props) => {
  const { label, type } = props
  const dispatch = useDispatch()
  const currentDate = useSelector((state: State) => getCurrentDate(state))

  const selectedDate = type === 'prev' ? addDays(currentDate, -1) : addDays(currentDate, 1)

  return (
    <button className={styles.button__arrow_daily} onClick={() => dispatch(handleCurrentDate(selectedDate))}>
      <p>
        <img src={`/icon/arrow_${type}.svg`} alt={label} />
      </p>
      {label}
    </button>
  )
})

export default DailyArrowButton
